import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
const inputStyle = {
    fieldset: {
        borderRadius: '0px',
        borderWidth: '1px',
        borderColor: '#728085',
        '&.MuiOutlinedInput-notchedOutline': {
            borderColor: '#728085 !important'
        }
    },
    input: {
        color: '#728085',
        '&.MuiInputBase-input::placeholder': {  // ✅ CORRECT SELECTOR
            color: '#728085',
            opacity: 1  // Ensures full opacity
        }
    }
};
export default function ForgotPassword() {
    return (
        <Box paddingTop={{ md: '208px', xs: '50px' }} paddingBottom={{ md: '418px', xs: '50px' }} display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <Box width={{ md: '560px', sm: '80%', xs: '90%' }} marginX={'auto'}>
                <Grid container spacing={4}>
                    <Grid size={12}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <Typography textAlign={'center'} variant="h1" fontFamily={'DanmarkURW'} className='dColor' fontSize={'2.875rem'} fontWeight={'bold'}>Forgot your password?</Typography>
                            </Grid>
                            <Grid size={12}>
                                <Typography marginX={'auto'} variant="body1" className='dColor' fontSize={'1.125rem'} textAlign={'center'} width={{ md: '330px', xs: '100%' }}>
                                    Shkruani më poshtë emailin tuaj për të ndryshuar fjalëkalimin e llogarisë.
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={12}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <Grid container>
                                    <Grid size={12}>
                                        <Box sx={inputStyle}>
                                            <TextField fullWidth placeholder='Email Address' />
                                            <Typography variant="body1" color="#F03C44" marginLeft={'10px'} marginBottom={'34px'} marginTop={'17px'} fontSize={'1rem'}>Kërkohet email adresa juaj</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid size={12}>
                                        <Button fullWidth variant='outlined' className='borderRadiusFlat borderWidth2 buttonPaddingY10 defaultBorderColor' sx={{ backgroundColor: 'text.secondary', color: 'text.primary', textTransform: 'unset' }}>Send</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>


        </Box>
    )
}
